class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const cartItems =
                this.closest("cart-items") || this.closest("cart-drawer-items");
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();

        this.lineItemStatusElement =
            document.getElementById("shopping-cart-line-item-status") ||
            document.getElementById("CartDrawer-LineItemStatus");

        this.currentItemCount = Array.from(
            this.querySelectorAll('[name="updates[]"]')
        ).reduce(
            (total, quantityInput) => total + parseInt(quantityInput.value),
            0
        );
        this.freeShippingBar = this.querySelector("#free-shipping-bar") || this.querySelector("#free-shipping-bar-cartpage");

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
            if (this.freeShippingBar) {
                this.updateFreeShippingBar(this.calculateTotalPriceExclusion());
            }            
        }, 300);

        this.addEventListener("change", this.debouncedOnChange.bind(this));

        if (this.freeShippingBar) {
            this.updateFreeShippingBar(this.calculateTotalPriceExclusion());
        }
    }
    
    onChange(event) {
        this.updateQuantity(
            event.target.dataset.index,
            event.target.value,
            document.activeElement.getAttribute("name")
        );
    }

    getSectionsToRender() {
        return [
            {
                id: "cart",
                section: "cart",
                selector: "#cart",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
            {
                id: "cart-live-region-text",
                section: "cart-live-region-text",
                selector: ".shopify-section",
            },
        ];
    }

    async updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map(
                (section) => section.section
            ),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then(async (state) => {
                const parsedState = JSON.parse(state);
                this.classList.toggle("is-empty", parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector("cart-drawer");

                if (cartDrawerWrapper)
                    cartDrawerWrapper.classList.toggle(
                        "is-empty",
                        parsedState.item_count === 0
                    );

                if (!parsedState.sections) {
                    const sections = await fetch(`${window.location.pathname}?sections=${this.getSectionsToRender().map(section => section.id)}`)
                    parsedState.sections = await sections.json()
                }
                this.getSectionsToRender().forEach((section) => {
                    const elementToReplace =
                        document
                            .getElementById(section.id)
                            .querySelector(section.selector) ||
                        document.getElementById(section.id);
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    );
                });

                if (typeof yotpoWidgetsContainer !== 'undefined' && parsedState.item_count != 0) {
                    yotpoWidgetsContainer.initWidgets();
                }

                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem =
                    document.getElementById(`CartItem-${line}`) ||
                    document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(
                                cartDrawerWrapper,
                                lineItem.querySelector(`[name="${name}"]`)
                          )
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    cartDrawerWrapper.displayRandomQuote();
                    trapFocus(
                        cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                        cartDrawerWrapper.querySelector("a")
                    );
                } else if (
                    document.querySelector(".cart-item") &&
                    cartDrawerWrapper
                ) {
                    trapFocus(
                        cartDrawerWrapper,
                        document.querySelector(".cart-item__link")
                    );
                }
                this.disableLoading();
            })
            .catch(() => {
                const errors =
                    document.getElementById("cart-errors") ||
                    document.getElementById("CartDrawer-CartErrors");
                if( errors ){
                    errors.classList.remove('dn');
                    errors.textContent = window.cartStrings.error;
                }
                this.disableLoading();
            });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError =
                document.getElementById(`Line-item-error-${line}`) ||
                document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement =
                document.getElementById(`Quantity-${line}`) ||
                document.getElementById(`Drawer-quantity-${line}`);

            lineItemError.querySelector(".cart-item__error-text").innerHTML =
                window.cartStrings.quantityError.replace(
                    "[quantity]",
                    quantityElement.value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);

        const cartStatus =
            document.getElementById("cart-live-region-text") ||
            document.getElementById("CartDrawer-LiveRegionText");
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.add("pointer-none");
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }

    disableLoading() {
        const mainCartItems =document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.remove("pointer-none");
    }

    updateFreeShippingBar(totalPrice) {
        if (!this.freeShippingBar) return;
        const freeShippingThreshold = this.freeShippingBar.dataset.freeShippingThreshold * 100;
        const remainingAmount = freeShippingThreshold - totalPrice;
        const progressBar = this.querySelector(".progress-bar");
        const remainingAmountElement = this.freeShippingBar.querySelector(".remaining-amount");
        const freeShippingMessageContainer = this.freeShippingBar.querySelector(".free-shipping-message");
        const freeShippingAchievedMessage = this.freeShippingBar.dataset.freeShippingMessage;
        const cartTotalPriceExclusion = document.querySelector('.cart-total-price-exclusion');

        if (remainingAmount > 0) {
            if (remainingAmountElement) {
                remainingAmountElement.textContent = `$${Math.ceil(remainingAmount / 100)}`;
            }
            progressBar.style.width = `${(totalPrice / freeShippingThreshold) * 100}%`;
        } else {
            freeShippingAchievedMessage ? freeShippingMessageContainer.textContent = freeShippingAchievedMessage : freeShippingMessageContainer.textContent = "Congratulations! You've got free shipping.";
            progressBar.style.width = "100%";
            cartTotalPriceExclusion.style.color = "green";
        }
        
        cartTotalPriceExclusion.textContent = `$${(totalPrice / 100).toFixed(2)}`;
    }

    calculateTotalPriceExclusion() {
        const cartItems = this.querySelectorAll("article.cart-item") || this.closest("cart-drawer-items .cart-item");
        let totalPriceExclusion = 0;

        cartItems.forEach(item => {
            console.log(item.id + ": " + item.dataset.itemExclusion);
            if (!item.dataset.itemExclusion) {
                const itemPrice = parseInt(item.querySelector('.price').textContent.replace('$', '').replace(',', '')) * 100;
                const itemQuantity = parseInt(item.querySelector('[name="updates[]"]').value);
                totalPriceExclusion += itemPrice * itemQuantity;
            }
        });
        return totalPriceExclusion;
    }
}

customElements.define("cart-items", CartItems);

class CartTextarea extends HTMLElement {
    constructor() {
        super();
        this.addEventListener(
            "change",
            debounce((event) => {
                const body = this.getData( event.target.value );
                fetch(`${routes.cart_update_url}`, {
                    ...fetchConfig(),
                    ...{ body },
                });
            }, 300)
        );
        this.addEventListener('input', (event) => {
            this.querySelector('.form__input--count-curr').textContent = event.target.value.length
        });
    }
    getData( value ){
        return JSON.stringify({ note: value });
    }
}
if (!customElements.get("cart-note")) {
    customElements.define(
        "cart-note",
        class CartNote extends CartTextarea {
            constructor() {
                super();
            }
            getData( value ){
                return JSON.stringify({attributes: {"Customer Note": value}});
            }
        }
    );
}

if (!customElements.get("cart-gift-note")) {
    customElements.define(
        "cart-gift-note",
        class CartGiftNote extends CartTextarea {
            constructor() {
                super();
            }
        }
    );
}